// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7849b372","453":"4c238ccd","732":"197ecf08"}[chunkId] + ".chunk.js";
};